(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"index_atlas_1", frames: [[1922,108,45,79],[402,1082,545,106],[402,1190,256,29],[660,1190,164,29],[1922,189,2,17],[1911,1136,125,52],[1922,0,117,52],[1227,1136,268,52],[1795,1082,164,52],[1744,1136,165,52],[949,1082,356,52],[949,1136,276,52],[1497,1136,245,52],[1560,1082,233,52],[1307,1082,251,52],[1922,54,115,52],[0,0,1920,1080],[0,1082,400,379]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_31 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_30 = function() {
	this.initialize(img.CachedBmp_30);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2204,112);


(lib.CachedBmp_32 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_28 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_27 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_26 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_25 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_24 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_23 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_22 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_21 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_20 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_19 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_18 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_17 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_16 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_15 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.Fundo = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.Fundo_gradiente = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.stripe = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// stripe
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#D6BC9C").beginStroke().moveTo(-41,45).lineTo(-41,-45).lineTo(41,-45).lineTo(41,45).closePath();
	this.shape.setTransform(0,0,1.0962,1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-45,-45,90,90);


(lib.sign_out_text = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// SignOutText
	this.instance = new lib.CachedBmp_31();
	this.instance.setTransform(0,-0.95,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.sign_out_text, new cjs.Rectangle(0,-0.9,22.5,39.5), null);


(lib.sign_out_background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// SignOutBackground
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#720F11").beginStroke().moveTo(-20,30).lineTo(-20,-30).lineTo(20,-30).lineTo(20,30).closePath();
	this.shape.setTransform(20,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.sign_out_background, new cjs.Rectangle(0,0,40,60), null);


(lib.separador = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEEFE7").beginStroke().moveTo(-5.8,5.8).curveTo(-8.1,3.4,-8.1,0).curveTo(-8.1,-3.4,-5.8,-5.8).curveTo(-3.4,-8.1,-0,-8.2).curveTo(3.4,-8.1,5.7,-5.8).curveTo(8.2,-3.4,8.2,0).curveTo(8.2,3.4,5.7,5.8).curveTo(3.4,8.1,-0,8.1).curveTo(-3.4,8.1,-5.8,5.8).closePath();
	this.shape.setTransform(3.5031,3.5231,0.4294,0.4294);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.separador, new cjs.Rectangle(0,0,7,7), null);


(lib.pseudo_after = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// MenuPseudoAfter
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(183,161,141,0.498)").beginStroke().moveTo(-78.5,30).lineTo(-78.5,-30).lineTo(78.6,-30).lineTo(78.6,30).closePath();
	this.shape.setTransform(35.575,30,0.4529,1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.pseudo_after, new cjs.Rectangle(0,0,71.2,60), null);


(lib.menu_line_solid = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(4,0,1).moveTo(-960,0).lineTo(960,0);
	this.shape.setTransform(960,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.menu_line_solid, new cjs.Rectangle(-2,-2,1924,4), null);


(lib.menu_line_gradient = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#5BC3BE","#1F4F6E"],[0,1],-680,0,680,0).beginStroke().moveTo(-680,1).lineTo(-680,-1).lineTo(680,-1).lineTo(680,1).closePath();
	this.shape.setTransform(680,1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.menu_line_gradient, new cjs.Rectangle(0,0,1360,2), null);


(lib.menu_line_double = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.instance = new lib.CachedBmp_30();
	this.instance.setTransform(-1,-1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.menu_line_double, new cjs.Rectangle(-1,-1,1102,56), null);


(lib.logo_small = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CachedBmp_32();
	this.instance.setTransform(-26.45,-1.9,0.5,0.5);

	this.instance_1 = new lib.CachedBmp_28();
	this.instance_1.setTransform(88.4,42.5,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_27();
	this.instance_2.setTransform(4.15,42.5,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_26();
	this.instance_3.setTransform(86.2,46.15,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo_small, new cjs.Rectangle(-26.4,-1.9,272.5,58.9), null);


(lib.botoes = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-236.1,78).lineTo(-236.1,-78).lineTo(236.1,-78).lineTo(236.1,78).closePath();
	this.shape.setTransform(236.05,78.025);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(3).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,472.1,156.1);


(lib.background_effect = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(19).call(this.frame_19).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.background_dynamic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {capa:0,localizacao:1,projeto:2,diferenciais:3,implantacao:4,orienta:5,fachada:6,perspectivas:7,plantas:8,ficha:9,vistas:10,video:11};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(12));

	// background
	this.instance = new lib.Fundo_gradiente();
	this.instance.setTransform(1520,0);

	this.instance_1 = new lib.Fundo();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(12));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2
	this.instance = new lib.Fundo_gradiente();
	this.instance.setTransform(1520,0);

	this.instance_1 = new lib.Fundo();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.background, new cjs.Rectangle(0,0,1920,1080), null);


(lib.arrow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEEFE7").beginStroke().moveTo(-24,12).lineTo(0,-12).lineTo(24,12).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-24,-12,48,24);


(lib.stripe_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {start:1,complete:11};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 *  Play the animate.
		 */
		this.gotoAndPlay('start');
	}
	this.frame_10 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		const AllTapParent = window.parent.AllTap;
		
		
		AllTapParent.emit('animate_strip', {complente: true});
	}
	this.frame_20 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		const AllTapParent = window.parent.AllTap;
		
		
		AllTapParent.emit('animate_strip', {end: true});
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(10).call(this.frame_10).wait(10).call(this.frame_20).wait(1));

	// stripe
	this.instance = new lib.stripe("synched",0);
	this.instance.setTransform(0,45);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({y:-40},5).to({y:-35},2).to({y:-45},2).to({startPosition:0},1).to({y:-35},2).to({y:-40},2).to({y:45},5).wait(1));

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-45,45).lineTo(-45,-45).lineTo(45,-45).lineTo(45,45).closePath();
	this.shape.setTransform(0,45);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(21));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-45,-90,90,180);


(lib.menu_background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// menu_line_double
	this.instance = new lib.menu_line_double();
	this.instance.setTransform(550,-52,1,1,0,0,0,550,27);
	this.instance.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// menu_line_solid
	this.instance_1 = new lib.menu_line_solid();
	this.instance_1.setTransform(960,-80,1,1,0,0,0,960,0);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// menu_line_gradient
	this.instance_2 = new lib.menu_line_gradient();
	this.instance_2.setTransform(1240,-79,1,1,0,0,0,680,1);
	this.instance_2.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#1C1815").beginStroke().moveTo(-960,40).lineTo(-960,-40).lineTo(960,-40).lineTo(960,40).closePath();
	this.shape.setTransform(960,-40);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.menu_background, new cjs.Rectangle(-2,-82,1924,82), null);


(lib.arrow_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(9).call(this.frame_9).wait(1));

	// arrow
	this.instance = new lib.arrow("synched",0);
	this.instance.setTransform(0,12);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:-26},5).to({y:-12},2).to({x:0.3,y:-18.4},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-24,-38,48.3,62);


(lib.menu_marker = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"capa":0,"localizacao":1,"projeto":2,"diferenciais":3,implantacoes:4,"orienta":5,"perspectivas":6,"plantas":7,"ficha":8,"vistas":9,"video":10};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(11));

	// arrow_up
	this.occ_animate = new lib.arrow_up();
	this.occ_animate.name = "occ_animate";
	this.occ_animate.setTransform(36.4,0);

	this.timeline.addTween(cjs.Tween.get(this.occ_animate).wait(1).to({x:688.95},0).wait(1).to({x:837.35},0).wait(1).to({x:985.55},0).wait(1).to({x:323.4},0).wait(1).to({x:508.1},0).wait(1).to({x:1116.8},0).wait(1).to({x:1225.9},0).wait(1).to({x:159.3},0).wait(1).to({x:1318.95},0).wait(1).to({x:1411.95},0).wait(1));

	// stripe_up
	this.instance = new lib.stripe_up();
	this.instance.setTransform(45.1,0,0.9996,1,0,0,0,0.1,0);
	this.instance.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},1).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1436,90);


// stage content:
(lib.index = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0];
	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		const 
			AllTap = window.AllTap,
			current_name = 'index';
			
		/**
		* Provisional
		*/
		//this.visible = false;
		//AllTap.$jQuery(window.document).find('.content-paginate').attr({style: 'height: 100%;'});
		/**
		* End provisional
		*/
		
		/**
		 *
		 *  @param object
		 *  Set "this", object of canvas CreateJs.
		 */
		AllTap.setState({...AllTap.state, [`_this_${current_name}`]: this});
		
		/**
		 *
		 * @param array
		 *  [{
		 *      name: {string} = Name of occurrence not prefixed here "btn_".
		 *      occ_logo_large: {boolean} = Is visible (optional) !this is hide by default.
		 *      occ_logo_medium: {boolean} = Is visible (optional) !this is hide by default.
		 *      occ_logo_small: {boolean} = Is visible (optional) !this is hide by default.
		 *      occ_background: {boolean} = Is visible (optional) !this is hide by default.
		 *      occ_background_dynamic: {boolean} = Is visible (optional), go to label current !this is hide by default.
		 *      occ_background_effect: {boolean} = Is visible (optional), auto executable movie clip in frame 0 !this is hide by default.
		 *      occ_external: {boolean} = Is visible (optional), open in new page target="_blank".
		 *      occ_video: {boolean} = Is button video, run outside the iFrame (optional).
		 *      occ_tour: {boolean} = Is button tour, run outside the iFrame (optional).
		 *            src: URL of external and video or tour.
		 *      page_default: {boolean} = Define function $page_default() "root", finish of video (optional).
		 *      page_after: {boolean} = Define function $page_after() "root", before page_default.
		 *		menu_disabled: {boolean} = Disable menu for page after.
		 *  }]
		 */
		AllTap.createMenu([
		    {
		        name: 'capa',
				occ_logo_small: true,
				occ_logo_large: true,
				occ_background_dynamic: true,
		        page_default: true
		    },
		    {
		        name: 'localizacao',
				occ_logo_small: true
		    },
		    {
		        name: 'projeto',
				occ_logo_small: true
		    },
			{
		        name: 'diferenciais',
				occ_logo_small: true
			},
			{
		        name: 'implantacoes',
				occ_logo_small: true
		    },
			{
		        name: 'orienta',
				occ_logo_small: true
		    },
		    {
		        name: 'perspectivas',
				occ_logo_small: true
		    },
		    {
		        name: 'fachada',
				occ_logo_small: true
		    },
		    {
		        name: 'plantas',
				occ_logo_small: true
		    },
			{
		        name: 'vistas',
				occ_logo_small: true
		    },
			{
		        name: 'ficha',
				occ_logo_small: true
		    },
			{
		        name: 'video',
				occ_logo_small: true,
				occ_video: true,
				src: 'public/media/video.mp4'
		    }
		]);
		
		AllTap.closeVideo();
		
		/*
		function prevMain() {
			window.open(`${window.location.protocol}//${window.location.host}`, "_self");
		}
		
		this.btn_sign_out.addEventListener("click", prevMain);
		*/
		this.btn_sign_out.addEventListener("click", fl_sair);
		
		function fl_sair() {
			window.open("http://127.0.0.1/portal-dialogo-web", "_self");
		}
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// BackgroundEffect
	this.occ_background_effect = new lib.background_effect();
	this.occ_background_effect.name = "occ_background_effect";
	this.occ_background_effect.setTransform(8.2,0.25);

	this.timeline.addTween(cjs.Tween.get(this.occ_background_effect).wait(1));

	// LogoSmall
	this.occ_logo_small = new lib.logo_small();
	this.occ_logo_small.name = "occ_logo_small";
	this.occ_logo_small.setTransform(56.55,1015.3,1.0001,0.9998,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.occ_logo_small).wait(1));

	// PALETA
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#404041").beginStroke().moveTo(-43,43).lineTo(-43,-43).lineTo(43,-43).lineTo(43,43).closePath();
	this.shape.setTransform(-78.25,523.25);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("#C38A66").beginStroke().moveTo(-43,43).lineTo(-43,-43).lineTo(43,-43).lineTo(43,43).closePath();
	this.shape_1.setTransform(-78.25,163.25);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("#58585A").beginStroke().moveTo(-43,43).lineTo(-43,-43).lineTo(43,-43).lineTo(43,43).closePath();
	this.shape_2.setTransform(-78.25,403.25);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.beginFill("#FEEFE7").beginStroke().moveTo(-43,43).lineTo(-43,-43).lineTo(43,-43).lineTo(43,43).closePath();
	this.shape_3.setTransform(-78.25,283.25);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.beginFill("#B7A18D").beginStroke().moveTo(-43,43).lineTo(-43,-43).lineTo(43,-43).lineTo(43,43).closePath();
	this.shape_4.setTransform(-78.25,43.25);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	// SignOutButton
	this.btn_sign_out = new lib.botoes();
	this.btn_sign_out.name = "btn_sign_out";
	this.btn_sign_out.setTransform(1932.5,1000,0.1059,0.5127);
	new cjs.ButtonHelper(this.btn_sign_out, 0, 1, 2, false, new lib.botoes(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_sign_out).wait(1));

	// sign_out_text
	this.instance = new lib.sign_out_text();
	this.instance.setTransform(1951.35,1021.3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// sign_out_background
	this.instance_1 = new lib.sign_out_background();
	this.instance_1.setTransform(1942.5,1010);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// MenuButton
	this.btn_video = new lib.botoes();
	this.btn_video.name = "btn_video";
	this.btn_video.setTransform(1708.15,1010.05,0.1637,0.3846,0,0,0,0.9,0);
	new cjs.ButtonHelper(this.btn_video, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_vistas = new lib.botoes();
	this.btn_vistas.name = "btn_vistas";
	this.btn_vistas.setTransform(1614.95,1010.05,0.1637,0.3846,0,0,0,0.9,0);
	new cjs.ButtonHelper(this.btn_vistas, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_perspectivas = new lib.botoes();
	this.btn_perspectivas.name = "btn_perspectivas";
	this.btn_perspectivas.setTransform(1400.35,1010,0.1953,0.3846,0,0,0,1.6,0);
	new cjs.ButtonHelper(this.btn_perspectivas, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_implantacoes = new lib.botoes();
	this.btn_implantacoes.name = "btn_implantacoes";
	this.btn_implantacoes.setTransform(590.3,1010,0.2989,0.3846,0,0,0,0.8,0);
	new cjs.ButtonHelper(this.btn_implantacoes, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_plantas = new lib.botoes();
	this.btn_plantas.name = "btn_plantas";
	this.btn_plantas.setTransform(1509.45,1010,0.1976,0.3846,0,0,0,1,0);
	new cjs.ButtonHelper(this.btn_plantas, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_projeto = new lib.botoes();
	this.btn_projeto.name = "btn_projeto";
	this.btn_projeto.setTransform(1111.4,1010.05,0.2493,0.384,0,0,0,1,0);
	new cjs.ButtonHelper(this.btn_projeto, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_ficha = new lib.botoes();
	this.btn_ficha.name = "btn_ficha";
	this.btn_ficha.setTransform(427.4,1010,0.3006,0.3846,0,0,0,0.8,0);
	new cjs.ButtonHelper(this.btn_ficha, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_orienta = new lib.botoes();
	this.btn_orienta.name = "btn_orienta";
	this.btn_orienta.setTransform(755.9,1010,0.376,0.3846,0,0,0,1.2,0);
	new cjs.ButtonHelper(this.btn_orienta, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_localizacao = new lib.botoes();
	this.btn_localizacao.name = "btn_localizacao";
	this.btn_localizacao.setTransform(956.7,1010,0.2848,0.3846,0,0,0,1.1,0);
	new cjs.ButtonHelper(this.btn_localizacao, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_capa = new lib.botoes();
	this.btn_capa.name = "btn_capa";
	this.btn_capa.setTransform(337.15,1010,0.1568,0.3843,0,0,0,1.6,0);
	new cjs.ButtonHelper(this.btn_capa, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_diferenciais = new lib.botoes();
	this.btn_diferenciais.name = "btn_diferenciais";
	this.btn_diferenciais.setTransform(1258.75,1010.05,0.2523,0.3846,0,0,0,1.2,0.1);
	new cjs.ButtonHelper(this.btn_diferenciais, 0, 1, 2, false, new lib.botoes(), 3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.btn_diferenciais},{t:this.btn_capa},{t:this.btn_localizacao},{t:this.btn_orienta},{t:this.btn_ficha},{t:this.btn_projeto},{t:this.btn_plantas},{t:this.btn_implantacoes},{t:this.btn_perspectivas},{t:this.btn_vistas},{t:this.btn_video}]}).wait(1));

	// MenuPseudoAfter
	this.instance_2 = new lib.pseudo_after();
	this.instance_2.setTransform(1821.3,1163.85,0.9547,0.6666,0,0,0,0.4,0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// MenuTitle
	this.instance_3 = new lib.separador();
	this.instance_3.setTransform(1248.55,1039.6,1,1,0,0,0,8.2,8.2);

	this.instance_4 = new lib.CachedBmp_25();
	this.instance_4.setTransform(1623.55,1020.2,0.5,0.5);

	this.instance_5 = new lib.separador();
	this.instance_5.setTransform(1706.6,1039.6,1,1,0,0,0,8.2,8.2);

	this.instance_6 = new lib.CachedBmp_24();
	this.instance_6.setTransform(1717,1020.2,0.5,0.5);

	this.instance_7 = new lib.separador();
	this.instance_7.setTransform(1612.6,1039.6,1,1,0,0,0,8.2,8.2);

	this.instance_8 = new lib.separador();
	this.instance_8.setTransform(1504.65,1039.6,1,1,0,0,0,8.2,8.2);

	this.instance_9 = new lib.separador();
	this.instance_9.setTransform(1397.15,1039.6,1,1,0,0,0,8.2,8.2);

	this.instance_10 = new lib.separador();
	this.instance_10.setTransform(1104,1039.6,1,1,0,0,0,8.2,8.2);

	this.instance_11 = new lib.separador();
	this.instance_11.setTransform(952.15,1039.6,1,1,0,0,0,8.2,8.2);

	this.instance_12 = new lib.separador();
	this.instance_12.setTransform(748.9,1039.6,1,1,0,0,0,8.2,8.2);

	this.instance_13 = new lib.separador();
	this.instance_13.setTransform(583.35,1039.6,1,1,0,0,0,8.2,8.2);

	this.instance_14 = new lib.separador();
	this.instance_14.setTransform(422.55,1039.6,1,1,0,0,0,8.2,8.2);

	this.instance_15 = new lib.CachedBmp_23();
	this.instance_15.setTransform(430.05,1020.2,0.5,0.5);

	this.instance_16 = new lib.CachedBmp_22();
	this.instance_16.setTransform(1513.75,1020.2,0.5,0.5);

	this.instance_17 = new lib.CachedBmp_21();
	this.instance_17.setTransform(1404.55,1020.2,0.5,0.5);

	this.instance_18 = new lib.CachedBmp_20();
	this.instance_18.setTransform(755.65,1020.2,0.5,0.5);

	this.instance_19 = new lib.CachedBmp_19();
	this.instance_19.setTransform(590.85,1020.2,0.5,0.5);

	this.instance_20 = new lib.CachedBmp_18();
	this.instance_20.setTransform(1255.35,1020.2,0.5,0.5);

	this.instance_21 = new lib.CachedBmp_17();
	this.instance_21.setTransform(1112.15,1020.2,0.5,0.5);

	this.instance_22 = new lib.CachedBmp_16();
	this.instance_22.setTransform(960.25,1020.2,0.5,0.5);

	this.instance_23 = new lib.CachedBmp_15();
	this.instance_23.setTransform(345.95,1020.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3}]}).wait(1));

	// MenuMarker
	this.occ_menu_marker = new lib.menu_marker();
	this.occ_menu_marker.name = "occ_menu_marker";
	this.occ_menu_marker.setTransform(332.15,1080);
	this.occ_menu_marker.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,-1,3);

	this.timeline.addTween(cjs.Tween.get(this.occ_menu_marker).wait(1));

	// MenuBackground
	this.occ_menu_background = new lib.menu_background();
	this.occ_menu_background.name = "occ_menu_background";
	this.occ_menu_background.setTransform(0,1080);

	this.timeline.addTween(cjs.Tween.get(this.occ_menu_background).wait(1));

	// background
	this.occ_background = new lib.background();
	this.occ_background.name = "occ_background";

	this.timeline.addTween(cjs.Tween.get(this.occ_background).wait(1));

	// BackgroundDynamic
	this.occ_background_dynamic = new lib.background_dynamic();
	this.occ_background_dynamic.name = "occ_background_dynamic";

	this.timeline.addTween(cjs.Tween.get(this.occ_background_dynamic).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(838.8,540,1143.7,663.8);
// library properties:
lib.properties = {
	id: '7C9EF5D5AF5D5F46AFF0D236F6A9A88F',
	width: 1920,
	height: 1080,
	fps: 30,
	color: "#1C1815",
	opacity: 1.00,
	manifest: [
		{src:"./images/CachedBmp_30.png", id:"CachedBmp_30"},
		{src:"./images/index_atlas_1.png", id:"index_atlas_1"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['7C9EF5D5AF5D5F46AFF0D236F6A9A88F'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
